import { Component } from 'react'

import { GridRemountBoundaryProps } from './types'

interface GridRemountBoundaryState {
  key: number
  retries: number
  failed: boolean
  errored: boolean
}

// @mui/x-data-grid's root throws "Rendered fewer hooks than expected" when a
// StrictMode double-effect-invoke overlaps a re-render shortly after mount
// (unresolved upstream: mui/mui-x#13356, reproduces on 7.x/8.x/9.x). Measured
// empirically, this takes a fixed number of remounts to clear (observed: 3,
// consistently) rather than being flaky, but that count isn't guaranteed
// stable across pages with different data-fetch timing, hence the margin.
class GridRemountBoundary extends Component<
  GridRemountBoundaryProps,
  GridRemountBoundaryState
> {
  state: GridRemountBoundaryState = {
    key: 0,
    retries: 0,
    failed: false,
    errored: false
  }

  // Con getDerivedStateFromError el error queda manejado: sin él React reintenta solo unas veces
  // y luego deja escapar el error aunque queden reintentos. `errored` evita volver a pintar los
  // hijos que acaban de fallar hasta que componentDidCatch decide el remonte.
  static getDerivedStateFromError() {
    return { errored: true }
  }

  componentDidCatch() {
    const maxRetries = this.props.maxRetries ?? 8
    this.setState((prev) =>
      prev.retries >= maxRetries
        ? { ...prev, failed: true, errored: false }
        : {
            key: prev.key + 1,
            retries: prev.retries + 1,
            failed: false,
            errored: false
          }
    )
  }

  render() {
    if (this.state.failed) return <p>No se pudo cargar la tabla.</p>
    if (this.state.errored) return null
    return <div key={this.state.key}>{this.props.children}</div>
  }
}

export default GridRemountBoundary
